import {createAction, createReducer} from '@reduxjs/toolkit';

import {MessageType} from 'types/cartType';

import {getQuote, removeQuoteItem} from '../../reducers/quoteItems/quoteItems';

import {
    changeUhcAllowanceItem,
    RejectedUhcAllowanceActionType,
} from '../applyingAllowance/applyingAllowance';

/**
 * Set cart messages
 * @param {Array<MessageType>} messages - messages
 * @return {ActionType<Array<MessageType>>} action
 */
export const setMessages = createAction<MessageType[]>('CART@SET_MESSAGES');

/**
 * Function for UHC allowance item
 *
 * @param {ActionType<ApplicationStoreType>} action - Received action
 * @returns {Array<MessageType>} updated state
 */
function handleUhcAllowanceItemRejected(
    payload?: RejectedUhcAllowanceActionType,
): Array<MessageType> {
    return (payload?.response?.data?.messages || {error: []}).error.map(error => ({
        ...error,
        type: 'error',
    }));
}

/**
 * Cart messages reducer
 *
 * @param {Array<MessageType>} state - Current state
 * @param {ActionType<AxiosPromise>} action - Received action
 * @returns {Array<MessageType>} updated state
 */
export const messages = createReducer<{message: string; type: string}[]>([], builder =>
    builder
        .addCase(getQuote.fulfilled, (_, action) => action?.payload?.data.messages)
        .addCase(removeQuoteItem.fulfilled, (_, action) => action?.payload?.data.messages)
        .addCase(setMessages, (_, action) => action?.payload)
        .addCase(changeUhcAllowanceItem.rejected, (_, action) =>
            handleUhcAllowanceItemRejected(action.payload),
        )
        .addCase(getQuote.rejected, (_, action) => action?.payload?.response?.data?.messages || []),
);
